import React from "react"

import DocsContainer from "features/Docs/containers/Docs.container"

const Docs: React.FC = () => {
  return (
    <>
      <title>DATA(Q) - Documentation</title>
      <DocsContainer />
    </>
  )
}

export default Docs
